import Content from '../../content';

namespace('IO.Views.PuppetProfiles', function (exports) {
  'use strict';

  exports.New = Content;
});
